import { z } from 'zod';
import { Avatar, HINT_KEYS, HintKey, IsoDateTime, Locale } from './common.ts';

export const NICKNAME_MIN = 3;
export const NICKNAME_MAX = 20;
export const DISPLAY_NAME_MAX = 40;

/** Letters of any script (Latin, Cyrillic…), digits, underscore and hyphen. */
export const NICKNAME_PATTERN = /^[\p{L}\p{N}_-]+$/u;

export const Nickname = z
  .string()
  .trim()
  .min(NICKNAME_MIN)
  .max(NICKNAME_MAX)
  .regex(NICKNAME_PATTERN, { message: 'nickname_charset' });

export const DisplayName = z.string().trim().min(1).max(DISPLAY_NAME_MAX);

export const MeDto = z.object({
  id: z.uuid(),
  nickname: z.string(),
  displayName: z.string(),
  avatar: Avatar,
  locale: Locale,
  /** From the identity provider token; not stored in the application database. */
  email: z.string().nullable(),
  /** First-time hints (U-LEARN-08): whether they are shown, and those already seen. */
  hintsOn: z.boolean(),
  /** Plain strings: a key dropped from a later version must not break the profile. */
  hintsSeen: z.array(z.string()),
  createdAt: IsoDateTime,
  lastSeenAt: IsoDateTime,
});
export type MeDto = z.infer<typeof MeDto>;

export const UpdateMeBody = z
  .object({
    nickname: Nickname,
    displayName: DisplayName,
    avatar: Avatar,
    locale: Locale,
    hintsOn: z.boolean(),
    /** The whole list; an empty one shows every hint again. */
    hintsSeen: z.array(HintKey).max(HINT_KEYS.length),
  })
  .partial()
  .strict()
  .refine((body) => Object.keys(body).length > 0, { message: 'empty_update' });
export type UpdateMeBody = z.infer<typeof UpdateMeBody>;
